(() => {
  if (window.__qcLazyVideoInit) return;
  window.__qcLazyVideoInit = true;

  const SELECTOR = 'video.js-lazy-video[data-video-src]';
  const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'scroll'];
  const DEFAULT_AUTOPLAY_BACKSTOP_MS = 0;

  function onceFirstInteraction(cb) {
    let done = false;
    const handler = () => {
      if (done) return;
      done = true;
      try {
        INTERACTION_EVENTS.forEach((evt) => window.removeEventListener(evt, handler, true));
      } catch (_) {}
      cb();
    };
    try {
      INTERACTION_EVENTS.forEach((evt) => window.addEventListener(evt, handler, true));
    } catch (_) {}
    return handler;
  }

  function loadVideo(el) {
    if (!el || el.dataset.loaded === 'true') return;
    const src = el.getAttribute('data-video-src');
    if (!src) return;

    const source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    el.insertBefore(source, el.firstChild);
    el.dataset.loaded = 'true';

    try {
      el.load();
    } catch (_) {}

    const wantsAutoplay = el.getAttribute('data-video-autoplay') === 'true' || el.autoplay;
    if (wantsAutoplay && typeof el.play === 'function') {
      const p = el.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }
  }

  function maybeLoadVideo(el) {
    if (!el || el.dataset.loaded === 'true') return;

    const wantsAutoplay = el.getAttribute('data-video-autoplay') === 'true' || el.autoplay;
    const trigger = (el.getAttribute('data-video-trigger') || '').toLowerCase();
    const backstopMsAttr = parseInt(el.getAttribute('data-video-backstop-ms') || '', 10);
    const autoplayBackstopMs = Number.isFinite(backstopMsAttr)
      ? Math.max(0, backstopMsAttr)
      : DEFAULT_AUTOPLAY_BACKSTOP_MS;

    if (trigger === 'viewport' || !wantsAutoplay) {
      loadVideo(el);
      return;
    }

    if (el.dataset.deferInit === 'true') return;
    el.dataset.deferInit = 'true';

    const run = () => loadVideo(el);
    const handler = onceFirstInteraction(run);
    if (autoplayBackstopMs > 0) {
      setTimeout(() => {
        try {
          INTERACTION_EVENTS.forEach((evt) => window.removeEventListener(evt, handler, true));
        } catch (_) {}
        run();
      }, autoplayBackstopMs);
    }
  }

  function init(root = document) {
    const videos = root.querySelectorAll(SELECTOR);
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(maybeLoadVideo);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            maybeLoadVideo(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px' },
    );

    videos.forEach((v) => io.observe(v));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  // Theme editor: re-init when sections are added/updated.
  document.addEventListener('shopify:section:load', (e) => init(e.target || document));
})();

